import { Admin, AdminRole, Maybe } from '@graph/schemas'

const internalAdminDomains = (): string[] => {
	const raw = import.meta.env.REACT_APP_INTERNAL_ADMIN_EMAIL_DOMAINS ?? ''
	return raw
		.split(',')
		.map((s) => s.trim())
		.filter(Boolean)
}

export const onlyAllowAdminRole = (admin?: Admin, role?: string) =>
	role === AdminRole.Admin

export const onlyAllowHighlightStaff = (admin?: Maybe<Admin>) =>
	import.meta.env.DEV ||
	internalAdminDomains().some(
		(d) => !!admin?.email && admin.email.toLowerCase().endsWith(d),
	) ||
	false
